<div 
    *ngIf="type === 'success'"
    class="fixed inset-0 flex items-center justify-center bg-main-background bg-opacity-75 z-40" role="alert"
    (click)="closeMessage()"
>
    <div class="min-w-96 max-w-md shadow-lg text-center" (click)="$event.stopPropagation()">
        <div class="w-full flex flex-col items-center justify-center">
            <div class="w-full px-6 pt-6 rounded-t-md flex flex-col items-center gap-4 bg-emerald-600">  
                <div class="w-full flex items-center justify-between">
                    <div class="flex items-center gap-2">
                        <div class="p-2 rounded-full bg-white">
                            <lucide-icon [name]="icons.Check" [size]="24" class="text-emerald-600"></lucide-icon>
                        </div>
                        <h2 class="oswald-font text-xl font-medium text-white text-start">
                            Successfully!
                        </h2>
                    </div>
                    <button
                        (click)="$event.preventDefault(); closeMessage();"
                    >
                        <lucide-icon [name]="icons.X" [size]="20" class="text-white"></lucide-icon>
                    </button>
                </div>
                <p class="break-words whitespace-pre-wrap w-full text-start pb-4 border-b border-emerald-600 text-white">{{ message || 'New record has been saved successfully.'}}</p>
            </div>
            <div class="w-full px-6 pb-6 pt-4 rounded-b-md bg-white flex items-center justify-end gap-3">
                <button 
                    class="px-4 py-2 w-20 rounded-md border border-nside-gray-200 oswald-font text-nside-gray-200"
                    (click)="$event.preventDefault(); closeMessage();"
                >
                    Close
                </button>
            </div>
        </div>
    </div>
</div>

<div 
    *ngIf="type === 'unsuccess'"
    class="fixed inset-0 flex items-center justify-center bg-main-background bg-opacity-75 z-30" role="alert"
    (click)="closeMessage()"
>
    <div class="min-w-96 max-w-md shadow-lg text-center" (click)="$event.stopPropagation()">
        <div class="w-full flex flex-col items-center justify-center">
            <div class="w-full px-6 pt-6 rounded-t-md flex flex-col items-center gap-4 bg-red-700">  
                <div class="w-full flex items-center justify-between">
                    <div class="flex items-center gap-2">
                        <div class="p-2 rounded-full bg-white">
                            <lucide-icon [name]="icons.X" [size]="24" class="text-red-700"></lucide-icon>
                        </div>
                        <h2 class="oswald-font text-xl font-medium text-white text-start">
                            Error!
                        </h2>
                    </div>
                    <button
                        (click)="$event.preventDefault(); closeMessage();"
                    >
                        <lucide-icon [name]="icons.X" [size]="20" class="text-white"></lucide-icon>
                    </button>
                </div>
                <p class="break-words whitespace-pre-wrap w-full text-start pb-4 text-white">{{ message || 'Sorry, an error has occurred.' }}</p>
            </div>
            <div class="w-full px-6 pb-6 pt-4 rounded-b-md bg-white flex items-center justify-end gap-3">
                <button 
                    class="px-4 py-2 w-20 rounded-md border border-nside-gray-200 oswald-font text-nside-gray-200"
                    (click)="$event.preventDefault(); closeMessage();"
                >
                    Close
                </button>
            </div>
        </div>
    </div>
</div>